module.exports = __webpack_public_path__ + "90b4de2f065e8935a3ae91a3ce3827d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_2.jpg
// module id = 1666
// module chunks = 5